import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Notification from '../components/common/notification/Notification';

import './Layout.css';
import Login from './login/Login';
import AuthRoute from '../services/AuthRoute';
import HomeScreen from './HomeScreen';
import JourneyScreen from './journey1/JourneyScreen';
import PublicContext from "../PublicContext";
import RefreshToken from "../components/common/authentication/RefreshToken";
import LegalNotice from "../components/legalnotice/LegalNotice";
import DataPrivacy from "../components/dataprivacy/DataPrivacy";

class Layout extends Component {

  render() {
    return (
      <RefreshToken>
        <div className={"main-section"}>
          <main role="main" className="customer-main" id="content" tabIndex="-1">
            <Notification/>

            <Switch>
              <Route exact path="/public/login" component={Login}/>
              <AuthRoute path="/public/home" component={HomeScreen}/>
              <Route path="/public/token-receiver" component={Login}/>
              <AuthRoute path="/public/journey" component={JourneyScreen}/>
              <Route exact path="/public/c/:dealer/:brand" component={PublicContext}/>
              <Route exact path="/public/c/:brand" component={PublicContext}/>
              <Route exact path="/public/legal-notice" component={LegalNotice}/>
              <Route exact path="/public/data-privacy" component={DataPrivacy}/>
              <Redirect from="/public*" to="/public/login"/>
            </Switch>
          </main>
        </div>
      </RefreshToken>);
  }
}

export default Layout;

